import { render, staticRenderFns } from "./orderRecoveryDataTable.vue?vue&type=template&id=5e3efbd5&"
import script from "./orderRecoveryDataTable.vue?vue&type=script&lang=js&"
export * from "./orderRecoveryDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports